import { getTestIds } from 'seagull/utils/TestIds';
export const CLIENT_DETAILS_FORM_DEFAULTS = {
    clientType: 'business',
    name: ''
};
export const GetClientDetailsFormTID = (parentTestId)=>getTestIds(parentTestId);
